<template>
    <b-input-group class="category-select">
        <multiselect
                :options="categories"
                :label="trackByLabel"
                :track-by="trackByValue"
                v-model="selected"
                selectLabel=""
                placeholder="Select a category"
                tagPlaceholder=" "
                deselectLabel=""
                :disabled="internalDisable"
        >
            <template slot="clear"
                      v-if="selected && !internalDisable"
            >
                <div
                        class="clear-select"
                >
                    <font-awesome-icon
                            @mousedown.prevent.stop="selected = null"
                            :icon="['far', 'times']">
                    </font-awesome-icon>
                </div>
            </template>
            <template slot="caret">
                <caret-icon></caret-icon>
            </template>
        </multiselect>
        <b-input-group-append v-if="confirmButtons && allowed" class="transparent">
            <b-btn
                    v-if="internalDisable"
                    @click="internalDisable = false"
            >
                <font-awesome-icon
                        :icon="['far', 'pencil']"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="!internalDisable && !loading"
                    @click="onConfirm"
            >
                <font-awesome-icon
                        :icon="['fal', 'check']"
                        class="green"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="!internalDisable && !loading"
                    @click="onCancel"
            >
                <font-awesome-icon
                        :icon="['far', 'times']"
                        class="red"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="loading"
            >
                <font-awesome-icon
                        :icon="['fal', 'spinner']"
                        size="sm"
                        spin
                >
                </font-awesome-icon>
            </b-btn>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'Category-Select',
  props: {
    options: {},
    value: {},
    confirmButtons: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    trackByValue: null,
    trackByLabel: null,
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      allowed: false,
      internalDisable: false,
      selected: null,
      originalSelected: null,
      categories: [],
    };
  },

  watch: {
    value: {
      handler(newValue) {
        this.selected = newValue;
        this.originalSelected = cloneDeep(newValue);
      },
      immediate: true,
      deep: true,
    },
    options(newOptions) {
      this.categories = newOptions;
    },
    confirmButtons: {
      handler(newConfirmButtons) {
        this.allowed = newConfirmButtons;
      },
      immediate: true,
    },
    disabled: {
      handler(newDisabled) {
        this.internalDisable = newDisabled;
      },
      immediate: true,
    },
  },

  mounted() {
    this.categories = this.options;
    if (this.confirmButtons) {
      this.internalDisable = true;
    }
  },

  methods: {
    onCancel() {
      this.selected = this.originalSelected;
      this.disable();
    },
    onConfirm() {
      this.$emit('input', this.selected);
      this.$emit('confirm', this.selected);
    },
    disable() {
      this.internalDisable = true;
    },
    onInput(value) {
      if (!this.confirmButtons && !this.internalDisable) {
        this.$emit('input', value);
      }
    },
  },
};
</script>

<style lang="scss">
    .assign-select {
        .multiselect__option {
            padding-left: 25px;

            &--internalDisable {
                padding-left: 10px;
            }
        }
    }
</style>
